import { Dialog } from "@radix-ui/themes";
import { FC, ReactElement } from "react";
import "./index.css";

type ModalProps = {
  trigger: ReactElement;
  title?: string;
  children?: React.ReactNode;
};

export const Modal: FC<ModalProps> = (props) => {
  const { trigger, title, children } = props;
  return (
    <Dialog.Root>
      <Dialog.Trigger>{trigger}</Dialog.Trigger>
      <Dialog.Content maxWidth={"1050px"}>
        <Dialog.Title>{title}</Dialog.Title>
        {children}
      </Dialog.Content>
    </Dialog.Root>
  );
};
